<template>
    <div class="page-container">
        <table>
            <thead>
            </thead>
            <tbody>
                <tr style="height:60px;text-align:left;">
                    <td colspan="11" style="text-indent:15px;font-size:16px;font-weight:600;">志愿者详情</td>
                    <td rowspan="3" style="text-align:center;width:106px;height:159px;"><img :src="dataInfo.volunteer.headerPic" alt="" preview="1" style="width:106px;height:159px;vertical-align:middle;"></td>
                </tr>
                <tr style="height:50px;text-align:center;">
                    <td style="font-size:14px;font-weight:600;">姓名</td>
                    <td>{{dataInfo.volunteer.userName}}</td>
                    <td style="font-size:14px;font-weight:600;">性别</td>
                    <td>{{dataInfo.volunteer.sex}}</td>
                    <td style="font-size:14px;font-weight:600;">民族</td>
                    <td>{{dataInfo.volunteer.nation}}</td>
                    <td style="font-size:14px;font-weight:600;">身份证编号</td>
                    <td colspan="4">{{dataInfo.volunteer.idCard}}</td>
                    
                </tr>
                <tr style="height:50px;text-align:center;">
                    <td style="font-size:14px;font-weight:600;">出生年月</td>
                    <td>{{dataInfo.volunteer.birthday}}</td>
                    <td style="font-size:14px;font-weight:600;">年龄</td>
                    <td>{{dataInfo.volunteer.age}}</td>
                    <td style="font-size:14px;font-weight:600;">文化程度</td>
                    <td>{{dataInfo.volunteer.education}}</td>
                    <td style="font-size:14px;font-weight:600;">积分</td>
                    <td>{{dataInfo.volunteer.integral}}</td>
                    <td style="font-size:14px;font-weight:600;">联系电话</td>
                    <td colspan="2">{{dataInfo.volunteer.mobileNo}}</td>
                </tr>
                <tr style="height:50px;text-align:center;">
                    <td style="font-size:14px;font-weight:600;">所在区域</td>
                    <td colspan="5">{{dataInfo.volunteer.ownArea}}</td>
                    <td style="font-size:14px;font-weight:600;">职业类型</td>
                    <td colspan="5">{{dataInfo.volunteer.jobType}}</td>
                </tr>
                <tr style="height:50px;text-align:center;">
                    <td style="font-size:14px;font-weight:600;">联系地址</td>
                    <td colspan="5">{{dataInfo.volunteer.address}}</td>
                    <td style="font-size:14px;font-weight:600;">服务时间</td>
                    <td colspan="5">{{dataInfo.volunteer.serviceTimes}}</td>
                </tr>
                <tr style="height:50px;text-align:center;">
                    <td style="font-size:14px;font-weight:600;">服务技能</td>
                    <td colspan="5">{{dataInfo.volunteer.skill}}</td>
                    <td style="font-size:14px;font-weight:600;">个人说明</td>
                    <td colspan="5">{{dataInfo.volunteer.remark}}</td>
                </tr>
            </tbody>
            <!-- 暂时没有,先注释掉 -->
            <!-- <tfoot>
                <tr style="height:60px;text-align:left;">
                    <td colspan="12" style="text-indent:15px;font-size:16px;font-weight:600;">帮扶对象信息</td>
                </tr>
                <tr style="height:40px;text-align:center;font-size:14px;font-weight:600;">
                    <td>姓名</td>
                    <td colspan="2">身份证号</td>
                    <td>年龄</td>
                    <td>联系方式</td>
                    <td>性别</td>
                    <td colspan="2">联系地址</td>
                    <td colspan="2">所属服务社区</td>
                    <td colspan="2">所属区域</td>
                </tr>
                <tr style="height:50px;text-align:center;">
                    <td>{{dataInfo.recipients.name}}</td>
                    <td colspan="2">{{dataInfo.recipients.idCard}}</td>
                    <td>{{dataInfo.recipients.age}}</td>
                    <td>{{dataInfo.recipients.phone}}</td>
                    <td>{{dataInfo.recipients.sex}}</td>
                    <td colspan="2">{{dataInfo.recipients.contactAddress}}</td>
                    <td colspan="2">{{dataInfo.recipients.regionalCommunity}}</td>
                    <td colspan="2">{{dataInfo.recipients.area}}</td>
                </tr>
            </tfoot> -->
        </table>
    </div>
</template>
<script>
export default {
    name:'voluteerCommon',
    props:{
        dataInfo: {// 表格数据
            type:Object,
            required:true
        }, 
    },
    data(){
        return {

        }
    },
    methods:{
        
    },
    mounted(){
       
    }
}
</script>
<style lang="scss" scoped>
    table {
        margin:30px 5px;
        border-collapse:collapse;
        border:1px solid #cccccc;
    }
    td {
        border:1px solid #cccccc;
    }
    img{
        cursor: pointer;
    }
</style>
